export class PermissionConstants {
  public static readonly admin_servicecatalog_view = 'Admin.ServiceCatalog.View';
  public static readonly admin_problems_view = 'Admin.Problems.View';
  public static readonly admin_adminPanel_view = 'Admin.AdminPanel.View';
  public static readonly admin_notificationTemplates_view = 'Admin.NotificationTemplates.View';
  public static readonly serviceCatalog_view_hidden = 'ServiceCatalog.View.Hidden';
  public static readonly orders_create_show_initiator = 'Orders.Create.Show.Initiator';
  public static readonly orders_create_canedit_servicetype = 'Orders.Create.CanEdit.ServiceType';
}
